export default "__VITE_ASSET__ece9c95b__"